


// import React, { useState } from "react";
// import { Menu, X, Search } from "lucide-react";
// import { Link, useLocation } from "react-router-dom";
// import logo from "../../assets/logo.jpg";
// import "./Navbar.css";

// const Navbar = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const location = useLocation(); // Get current path

//   return (
//     <nav className="navbar">
//       <div className="container">

//         {/* Logo & Company Name (Clickable) */}
//         <Link to="/" className="logo-section">
//           <img src={logo} alt="Puyvast Logo" className="logo-img" />
//           <div className="company-name">
//             <span className="company-bold">PuyVast</span>
//             <span className="company-light">Maritime India Pvt. Ltd.</span>
//           </div>
//         </Link>

//         {/* Navigation Menu */}
//         <ul className={`nav-links ${isOpen ? "open" : ""}`}>
//           <li><Link to="/" className={location.pathname === "/" ? "active" : ""}>Home</Link></li>
//           <li><Link to="/about" className={location.pathname === "/about" ? "active" : ""}>About Us</Link></li>
//           <li><Link to="/gallery" className={location.pathname === "/gallery" ? "active" : ""}>Gallery</Link></li>
//           <li><Link to="/locations" className={location.pathname === "/locations" ? "active" : ""}>Locations</Link></li>
//           <li><Link to="/contact" className={location.pathname === "/contact" ? "active" : ""}>Contact Us</Link></li>
//         </ul>

//         {/* Right Section (Career & Enquiry) */}
//         <div className="right-section">
//           <div className="top-links">
//             <Link to="/careers" className="icon-link"><span className="icon">💼</span> Careers</Link>
//             <Link to="/enquiry" className="icon-link"><span className="icon">📞</span> Enquiry</Link>
//           </div>

//           {/* Search Box */}
//           <div className="search-box">
//             <input type="text" placeholder="Search..." />
//             <button className="search-btn"><Search size={18} /></button>
//           </div>
//         </div>

//         {/* Mobile Menu Toggle */}
//         <button className="menu-toggle" onClick={() => setIsOpen(!isOpen)}>
//           {isOpen ? <X size={24} /> : <Menu size={24} />}
//         </button>

//       </div>
//     </nav>
//   );
// };

// export default Navbar;












import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../assets/Logo puyvast.jpg";
import "./Navbar.css";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="navbar">
      <div className="container">
        {/* Logo & Company Name */}
        <Link to="/" className="logo-section">
          <img src={logo} alt="Puyvast Logo" className="logo-img" />
          <div className="company-name">
            <span className="company-bold">PuyVast</span>
            <span className="company-light">Logistics Pvt. Ltd.</span>
          </div>
        </Link>

        {/* Navigation Menu */}
        <ul className={`nav-links ${isOpen ? "open" : ""}`}>
          <li><Link to="/" className={location.pathname === "/" ? "active" : ""}>Home</Link></li>
          <li><Link to="/about" className={location.pathname === "/about" ? "active" : ""}>About Us</Link></li>
          <li><Link to="/gallery" className={location.pathname === "/gallery" ? "active" : ""}>Gallery</Link></li>
          <li><Link to="/locations" className={location.pathname === "/locations" ? "active" : ""}>Locations</Link></li>
          <li><Link to="/contact" className={location.pathname === "/contact" ? "active" : ""}>Contact Us</Link></li>
          <li><Link to="/careers" className={location.pathname === "/careers" ? "active" : ""}>Careers</Link></li>
        </ul>

        {/* Mobile Menu Toggle */}
        <button className="menu-toggle" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
